t = require('app/scripts/views/internal/teacup-with-helpers')('board_copy')

module.exports = ->
  t.form ->
    t.p ->
      t.format 'convert-board-to-template-text'
    t.input '.primary.wide.js-convert', { type: 'submit', value: t.l('convert-to-template') }
